"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  /** Epoch ms when generation started. `null` hides the indicator. */
  startedAt: number | null;
  /** Label rendered next to the spinner ("Генерация", "Удаляем фон"). */
  label?: string;
  className?: string;
}

/**
 * Spinner + label shown inside the "Generate" CTA while a job runs.
 * Earlier version showed an `MM:SS` ticker — dropped per design feedback;
 * the seconds counter felt clinical and added noise without telling the
 * user anything actionable.
 */
export function GenerationTimer({ startedAt, label = "Идёт генерация", className }: Props) {
  if (startedAt == null) return null;
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <Loader2 className="h-4 w-4 animate-spin shrink-0" />
      <span>{label}</span>
    </span>
  );
}
